import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SideNavInterface } from '../../../interfaces/side-nav.type';
import { AuthenticationService } from '../../../services/authentication.service';
import { ThemeConstantService } from '../../../services/theme-constant.service';
import { ROUTES } from './side-nav-routes.config';
import { User } from '../../../interfaces/user.type';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html',
})
export class SideNavComponent implements OnInit, OnDestroy {
  public menuItems: SideNavInterface[] = [];
  isFolded: boolean;
  isSideNavDark: boolean;
  isExpand: boolean;

  typeUser: number;
  userContext: User = null;
  private destroy$ = new Subject<void>();

  constructor(
    private themeService: ThemeConstantService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.authService.userContext.pipe(takeUntil(this.destroy$)).subscribe({
      next: (user) => {
        this.userContext = user;
        this.typeUser = this.userContext?.type;
        this.menuItems = this.filterRoutesByUserType(ROUTES, this.typeUser);
      }
    });

    this.themeService.isMenuFoldedChanges.pipe(takeUntil(this.destroy$)).subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isExpandChanges.pipe(takeUntil(this.destroy$)).subscribe(
      (isExpand) => (this.isExpand = isExpand)
    );
    this.themeService.isSideNavDarkChanges.pipe(takeUntil(this.destroy$)).subscribe(
      (isDark) => (this.isSideNavDark = isDark)
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  filterRoutesByUserType(
    routes: SideNavInterface[],
    userType: number
  ): SideNavInterface[] {
    return (routes ?? [])
      .filter((route) => (route.userType ?? []).includes(userType))
      .map((route) => {
        const filteredRoute: SideNavInterface = { ...route };

        if ((filteredRoute.submenu?.length ?? 0) > 0) {
          filteredRoute.submenu = this.filterRoutesByUserType(
            filteredRoute.submenu!,
            userType
          );
        } else {
          filteredRoute.submenu = filteredRoute.submenu ?? [];
        }

        return filteredRoute;
      })
      .filter((route) => {
        const isGroupOnly = (route.path ?? '') === '';
        const hasChildren = (route.submenu?.length ?? 0) > 0;
        return !(isGroupOnly && !hasChildren);
      });
  }

  ngAfterViewInit(): void {
    const submenus = document.querySelectorAll('.ant-menu li.ant-menu-submenu');
    const direction = document.documentElement.getAttribute('dir') ?? 'ltr';

    submenus.forEach((item) => {
      item.addEventListener('mouseover', function () {
        const menuItem = this as HTMLElement;
        const menuItemRect = menuItem.getBoundingClientRect();

        const submenuWrapper = menuItem.querySelector('ul.ant-menu-sub') as HTMLElement | null;
        if (!submenuWrapper) return;

        submenuWrapper.style.top = `${menuItemRect.top}px`;

        if (direction === 'ltr') {
          submenuWrapper.style.left = `${menuItemRect.left + Math.round(menuItem.offsetWidth * 0.75) + 10
            }px`;
        } else if (direction === 'rtl') {
          submenuWrapper.style.right = `${Math.round(menuItem.offsetWidth * 0.75) + 10}px`;
        }
      });
    });
  }

  closeMobileMenu(): void {
    if (window.innerWidth < 992) {
      this.isFolded = false;
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
      this.themeService.toggleFold(this.isFolded);
    }
  }
}
